'use client';
import {useMessages} from './locale';
import {ThemeProvider,useTheme} from 'next-themes';
import {useEffect,useState,type ReactNode} from 'react';
import {ThemeToggle} from './theme-toggle';
export function Providers({children}:{children:ReactNode}){return <ThemeProvider attribute="class" defaultTheme="system" enableSystem>{children}</ThemeProvider>}
export function ThemeSwitch(){const {resolvedTheme,setTheme}=useTheme(),t=useMessages();const [ready,setReady]=useState(false);useEffect(()=>setReady(true),[]);const dark=ready&&resolvedTheme==='dark';return <ThemeToggle dark={dark} label={dark?t.light:t.dark} disabled={!ready} onToggle={()=>setTheme(resolvedTheme==='dark'?'light':'dark')}/>}
